import React from "react";
import { useState, useEffect } from "react";
import "./App.css";
import handleUpdate from "./functions/handleUpdate";
import { Router } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { createBrowserHistory } from "history";
import firebase from "./firebase";
import Tool from "./Tool";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const history = createBrowserHistory();
//console.log('history: ', history);


const CurrentState = () => {
  const { listen } = useHistory();

  useEffect(() => {
    const unlisten = listen((location) => {
      handleUpdate();
      const analytics = firebase.analytics();
      const pagePath = location.pathname;
      analytics.logEvent("page_view", { page_path: pagePath });
    });
    return unlisten;
  }, [listen]);

  return <Tool />;
};

const App = () => {

  return (
    <Router history={history}>
        <CurrentState />
    </Router>
  );
};

export default App;